import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import CenterContent from '../Components/CenterContent/CenterContent'
import InstrumentsWrrapper from '../Components/InstrumentsWrrapper/InstrumentsWrrapper'
import { observer } from 'mobx-react-lite'
import SearchByName from './../block/accoutDocs/SearchByName'
import SearchByType from './../block/accoutDocs/SearchByType'
import { accountDocs } from './../store/accountDocs'
import { FaPlusSquare } from 'react-icons/fa'
import { FiEdit } from 'react-icons/fi'
import { MdDeleteOutline } from 'react-icons/md'
import DocsRegisModal from './../Components/Modal/DocsRegisModal'
import ConfirmModal from './../Components/Modal/ConfirmModal'
import http from './../Service/http'
import { toast } from 'react-toastify'

export const AccountDocsContainer = observer(function () {
	const { t } = useTranslation()
	const notify = (title: string) => toast(title)
	const [delModal, setDelModal] = useState<{
		modal: boolean
		id_docs: number
		name: string
	}>({
		modal: false,
		id_docs: 0,
		name: ''
	})

	const [modal, setModal] = useState<{
		modal: boolean
		stud: any
	}>({
		modal: false,
		stud: {}
	})
	const closeModalNotes = () => {
		setModal({
			modal: false,
			stud: null
		})
	}

	async function delDocs() {
		const res = await http.delete('/regis/academDocRegTableDelete?id_academ_document=' + delModal.id_docs)
		if (res) {
			const getDocsType = async (id: number) => {
				const a = await http.post('/regis/academDocRegTable', {
					reportType: id,
					s_fio_document: null
				})
				accountDocs.newDocs(a.data.AcademDocRegTable)
			}
			await getDocsType(0)
			setDelModal({
				modal: false,
				id_docs: 0,
				name: ''
			})
			notify(t('st:other.rejected'))
		}
	}

	return (
		<CenterContent>
			<DocsRegisModal setIsOpen={closeModalNotes} isOpen={modal.modal} stud={modal.stud} />
			<ConfirmModal
				setIsOpen={() => {
					setDelModal({
						modal: false,
						id_docs: 0,
						name: ''
					})
				}}
				title={delModal.name}
				isOpen={delModal.modal}
				hundleTrue={() => {
					if (delModal.id_docs) {
						delDocs()
					}
				}}
			/>
			<InstrumentsWrrapper
				leftHead={t('st:instrument.titles.searchByType')}
				rightHead={t('st:instrument.titles.searchByName')}
				leftChilds={<SearchByName />}
				rightChilds={<SearchByType />}
				leftIcon={<></>}
				rightIcon={<></>}
			/>
			<div className='TableWrapper'>
				<table>
					<thead>
						<tr>
							<th style={{ width: '5%' }}>№</th>
							<th style={{ width: '35%', textAlign: 'left' }}>{t('st:table.fio')}</th>
							<th style={{ width: '15%' }}>{t('st:accDocs.titles.doc')}</th>
							<th style={{ width: '15%' }}>{t('st:accDocs.titles.uin')}</th>
							<th style={{ width: '15%' }}>{t('st:accDocs.titles.regNum')}</th>
							<th style={{ width: '10%' }}>{t('st:accDocs.titles.dateIssue')}</th>
							<th style={{ width: '10%' }}>
								<FaPlusSquare
									onClick={() => {
										setModal({
											modal: true,
											stud: null
										})
									}}
								/>
							</th>
						</tr>
					</thead>
					<tbody>
						{accountDocs.docs.map((item, index) => {
							if (delModal.id_docs == item.id_akadem_document || modal.stud?.id_akadem_document == item?.id_akadem_document) {
								return (
									<tr key={index} className='active_line' onClick={() => {}}>
										<td>{index + 1}</td>
										<td style={{ textAlign: 'left' }}>{item.s_fio}</td>
										<td>{item.akadem_document_type}</td>
										<td>{item.document_numer}</td>
										<td>{item.document_reg_numer}</td>
										<td>{item.document_date}</td>
										<td>
											<div className='edit'>
												<FiEdit
													onClick={() => {
														setModal({
															modal: true,
															stud: item
														})
													}}
												/>
												<MdDeleteOutline
													onClick={() => {
														setDelModal({
															modal: true,
															id_docs: item.id_akadem_document,
															name: item.s_fio
														})
													}}
												/>
											</div>
										</td>
									</tr>
								)
							}
							return (
								<tr key={index} onClick={() => {}}>
									<td>{index + 1}</td>
									<td style={{ textAlign: 'left' }}>{item.s_fio}</td>
									<td>{item.akadem_document_type}</td>
									<td>{item.document_numer}</td>
									<td>{item.document_reg_numer}</td>
									<td>{item.document_date}</td>
									<td>
										<div className='edit'>
											<FiEdit
												onClick={() => {
													setModal({
														modal: true,
														stud: item
													})
												}}
											/>
											<MdDeleteOutline
												onClick={() => {
													setDelModal({
														modal: true,
														id_docs: item.id_akadem_document,
														name: item.s_fio
													})
												}}
											/>
										</div>
									</td>
								</tr>
							)
						})}
					</tbody>
				</table>
			</div>
		</CenterContent>
	)
})
